<template>
    <div class="all clearfix">
        <div class="mdCont bgff ">
           <div class="grid pb30">
                <div class="screen mt5">
                    <div class="item clearfix">
                        <span class="zu clearfix">
                            <span class="name">平台</span>
                            <span class="drop-down">
                                <button class="btn">{{curMedia}}<i class="icons fr"></i></button>
                                <ul class="option">
                                    <li v-for="(item,index) in mediaList" @click="dropDownChoose(index,1);" :key="index">{{index}}</li>
                                </ul>
                            </span>
                        </span>
                        <span class="zu yujin-text clearfix">
                            <span class="name">时间</span>
                            <span class="drop-down">
                                <vue-datepicker-local ref="timeSelect" v-model="timeRange" format="YYYY-MM-DD" :disabled-date="disabledDate"  show-buttons clearable @clear="selectedDate" @confirm="selectedDate" placeholder="请选择时间"/>
                            </span>
                        </span>
                        <div class="zu">
                            <button class="search-btn fr" @click="KeyUpEsc">搜索</button> 
                            <div class="hidden"><input type="text" placeholder="请输入标题关键词" class="input-text fl" v-model="keywords" @keyup.enter="KeyUpEsc"></div>
                        </div>
                    </div>
                </div>
                <div class="warp mt5 clearfix">
                    <div class="warp-body mh270">
                        <div class="no-data" v-if="nodata.hotList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                        <ul class="article-list">
                            <li class="imgText clearfix" v-for="(item,index) in hotList" :key="index">
                                <a v-if="item.isShowImg" class="img fl cp"  @click="showFavorDetail(item)"><img :src="item.isLoadStart?item.curImg:imgChose(item,index)" :onerror="defaultImg"/></a>
                                <div class="hidden">
                                    <div class="clearfix " :class="{'mt15':item.isShowImg}">
                                       <span class="collect ml20 cp fr" :class="{'curr':isFavor}" @click="favorites(item)"><i class="icons collect-icon"></i> 取消收藏</span>
                                        <h2 class="newsTit">
                                            <a class="cr00 fl cp" :class="curMedia!='微博'?'ovhidden':'ovhidden2'" @click="showFavorDetail(item)">{{item.news_title}}</a>
                                            <a class="cr27 fs12 fl mt5" :href="item.news_url"><i class="icons icon-link mt0"></i> 原文链接</a>
                                        </h2>
                                    </div>
                                    <p class="ovhidden2 mt5">{{item.news_digest}}</p>
                                    <p class="ziduan mt10 cr77">
                                        <span><i class="icons sm-icon" :class="showNewType(item.news_url_type,1)"></i>{{showNewType(item.news_url_type,2)}} ·  </span>
                                        <span>{{timeFilter(item.addtime)}}</span>
                                    </p>
                                </div>
                            </li>
                            
                        </ul>
                        <div class="mt20 ac" v-if="isShowMore">
                            <a class="btnMmore color-8a8a99" href="javascript:void(0);" @click="showMore">加载更多</a>
                        </div>
                        <div class="mt20 ac" v-if="isShowEnd">
                            <a class="more color-8a8a99" href="javascript:void(0);">数据已经全部加载完成啦~</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueDatepickerLocal from 'vue-datepicker-local';
export default {
    components: {VueDatepickerLocal},
    data() {
        return {
            curIcon:'web-icon',
            icons:{
                '微信':'wx-icon',
                '网页':'web-icon',
                '微博':'wb-icon',
                '头条':'toutiao-icon',
                '抖音':'dy-icon',
            },
            jzNewsList:[],
            defaultImg:'this.src="static/images/default.png"',
            curMedia:'全部',//当前媒体
            mediaList:{'全部':4,'网页':1,'微信':2,'微博':3,'头条':5,'抖音':6},//媒体下拉列表
            tags:'全部',
            hotList:[],
            pageCur:1,
            pageNum:6,
            dataCount:0,
            timeRange: [],
            startTime:null,
            endTime:null,
            keywords:'', //搜索关键词
            lastTime:'',
            isShowMore:false,
            isShowEnd:false,
            isFavor:true,
            nodata:{
                jzNewsList:false,
                hotList:false
            }
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.tags = that.$route.query.type;
            that.initialTime();
            that.hotListAjax();
            that.$utils.screenHeight();
        }) 
    },
    watch: {
		$route(){
			let that = this;
            that.tags = that.$route.query.type;
            that.$refs.left.curType = that.tags;
            that.keywords = '';
            that.clearListData();
		},
	},
    methods: {
        // 获取当前时间和7天前时间
        initialTime() {
            let max = '';
            let min = '';
            let nowTime = this.$utils.getNowDate(1);
            let n = nowTime.split(' ');
            let n1 = n[0].split('-');
            let n2 = n[1].split(':');
            let oldTime = this.$utils.getBeforeDay(nowTime,7);
            let o = oldTime.split('-');
            max = new Date(n1[0], n1[1]-1, n1[2], n2[0], n2[1], n2[2])
            min = new Date(o[0], o[1]-1, o[2], n2[0], n2[1], n2[2])
            this.timeRange = [min,max];console.log(max)
            //进页面获取时间数据
            this.startTime = this.$utils.dateConversion(min,1);
            this.endTime = this.$utils.dateConversion(max,1);
        },
        dropDownChoose(index,type){
            let that = this;
            if(type===1){
                that.curMedia = index;
            }
            that.curIcon = that.icons[index];
            that.clearListData();
        },
        showNewType(type,num){
            let that = this;
            for (let key in that.mediaList) {
                if(that.mediaList[key] == type){
                    if(num ==1){
                        return that.icons[key];
                    }else{
                        return key;
                    }
                }
            }
        },
        hotListAjax(){
            let that = this;
            let datas={
                news_title:that.keywords,
                news_type:that.mediaList[that.curMedia],
                start_time:that.startTime,
                end_time:that.endTime,
                perpage:that.pageNum,
                page:that.pageCur,
            };
            that.$parent.loadModal(true,'数据加载中...');
            that.$api.get('user/collect/list',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.$parent.loadModal(false);
                    if(r.data.list.length<=0){
                        if(that.pageCur==1){
                            that.nodata.hotList = true;
                            return
                        }
                        that.isShowMore = false;
                        that.isShowEnd = true;
                        return
                    }else{
                        that.nodata.hotList = false;
                        that.isShowMore = true;
                    }
                    let data = r.data.list;
                    data.forEach(ele => {
                        ele.isLoadStart = false;
                        ele.isShowImg = true;
                    });
                    
                    let len = data.length;
                    that.hotList = that.hotList.concat(data);
                    console.log(data.length);
                });
            });
        },
        showMore(){
            let that = this;
            that.pageCur++;
            that.hotListAjax();
        },
        clearListData(){
            let that = this;
            that.isShowMore = false;
            that.isShowEnd = false;
            that.pageCur = 1;
            that.hotList = [];
            that.hotListAjax()
        },
        
        disabledDate (time) {
            //return time < this.min || time > this.max
        },
        selectedDate (date) {
            let that = this;
            if(date == undefined){
                that.startTime = '';
                that.endTime = '';  
            }else{
                that.startTime = that.$utils.dateConversion(that.timeRange[0],1);
                that.endTime = that.$utils.dateConversion(that.timeRange[1],1);
            }
            that.clearListData();
        },
        //搜索内容
        KeyUpEsc(){
            let that = this;
            that.clearListData();
        },
        timeFilter(t){
            var newT = '';
            if(t!=null){
                let tmp = t.split(':');
                newT = tmp[0]+':'+tmp[1];
                return newT;
            }
        },
        loadImg(ele,i,item,len){
            let that= this;
            let img = new Image()
            img.src = ele
            img.onload = function () {
                if(img.width>200 && ((img.width/img.height)<3)){
                    item.curImg = ele;
                    item.isLoadStart = true;
                    //console.log(img.width/img.height)
                    return
                }
                if(i>=(len-1)){
                    item.curImg = '';
                    item.isLoadStart = true;
                    item.isShowImg = false;
                    return 
                }
                that.loadImg(item.news_imgs[i+1],(i+1),item,len);
            }
        },
        imgChose(item,index){
            let that= this;
            if(item.news_imgs == null || item.news_imgs == ''){
                item.isLoadStart = true;
                item.curImg='';
                item.isShowImg = false;
                return;
            }
            let len = item.news_imgs.length;
            if(len==1 && item.news_imgs[0]==''){
                item.isLoadStart = true;
                item.curImg='';
                item.isShowImg = false;
                return;
            }
           that.loadImg(item.news_imgs[0],0,item,len); 
        },
        //取消收藏
        favorites(item){
            let that = this;
            let datas = {
                id:item.id,
            };
            that.$api.post('user/collect/del', datas, r => {
                that.$parent.returnCode(r,function(){
                    let data = r.data;
                    that.$utils.alertText("取消收藏成功！");
                    that.clearListData();
                })
            })
        },
        showFavorDetail(item){
            let that = this;
            let datas = {
                id:item.id,
            };
            that.$api.get('user/collect/get-param',datas,r=>{
                that.$parent.returnCode(r,function(){
                    let data = r.data;
                    let routeData = that.$router.resolve({ path: '/newsDetail', query: {id:data.id,newsType:data.news_type,type:data.type} });
                    window.open(routeData.href, '_blank');
                });
            });
        },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/myFavorites.vue